<list-chips *ngIf="chipsView" />
<div class="new-filters-modal" [hidden]="chipsView">
  <div class="title__wrapper">
    <span class="title">{{ 'List.Filters.filters' | translate }}</span>
    <svg-icon class="clear-icon" [src]="'/assets/img/close-icon.svg'" (click)="cancel()" />
  </div>
  <div class="rows__wrapper">
    <div class="new-filters-modal__row">
      <list-single-filter-select-v2
        class="w-100"
        [name]="'Contacts.List.role' | translate"
        [iconUrl]="'/assets/img/ic-tag.svg'"
        [form]="service?.filtersForm"
        [controlName]="'[function-name][eq]'"
        [bindLabel]="'name'"
        [bindValue]="'name'"
        [multiple]="false"
        [translateLabelPrefix]="'Contacts.Function.'"
        (change)="onChangeFilter()"
        [url]="Config.API + '/tag/type?type=contact-function'"
        (selectedValues)="handleSelectedValues($event, '[function-name][eq]')"
      />

      <list-single-filter-select-v2
        class="w-100"
        [name]="'Contacts.Fields.contactType' | translate"
        [iconUrl]="'/assets/img/ic-user.svg'"
        [form]="service?.filtersForm"
        [controlName]="'[a-type][in]'"
        [bindValue]="'id'"
        [bindLabel]="'name'"
        [multiple]="true"
        (change)="onChangeFilter()"
        [localItems]="contactTypes"
        (selectedValues)="handleSelectedValues($event, '[a-type][in]')"
      />
    </div>

    <div class="new-filters-modal__row">
      <list-single-filter-select-v2
        class="w-100"
        [name]="'Contacts.List.tags' | translate"
        [iconUrl]="'/assets/img/ic-projects-outline.svg'"
        [form]="service?.filtersForm"
        [controlName]="'[tags-id][in]'"
        [multiple]="true"
        bindLabel="name"
        bindValue="value"
        searchGetParams="search"
        (change)="onChangeFilter()"
        [selectedUrl]="Config.API + '/v2/contact/tag'"
        (selectedValues)="handleSelectedValues($event, '[tags-id][in]')"
      />

      <list-single-filter-select-v2
        class="w-100"
        [name]="'Contacts.List.creator' | translate"
        [iconUrl]="'/assets/img/ic-person-circle-outline.svg'"
        [form]="service?.filtersForm"
        [controlName]="'[creator-id][in]'"
        (change)="onChangeFilter()"
        [multiple]="true"
        [searchGetParams]="'search'"
        [requiredIdUrl]="Config.API + '/employee/search'"
        [sortByField]="'created'"
        [valueTransform]="creatorName.bind(this)"
        (selectedValues)="handleSelectedValues($event, '[creator-id][in]')"
      />
    </div>

    <list-single-filter-toggle
      [name]="'Contacts.List.showRemoved' | translate"
      [form]="service?.filtersForm"
      [controlName]="'[deleted]'"
      (change)="onChangeFilter()"
    />
  </div>

  <div class="buttons">
    <list-single-clear-filters-v2
      [form]="service?.filtersForm"
      (change)="onChangeFilter()"
      [shouldShowClearFilters]="shouldShowClearFilters.bind(this)"
      [clearFilters]="clearFilters.bind(this)"
    />
    <div class="buttons__inside">
      <app-button
        [type]="'button'"
        (onClick)="cancel()"
        [config]="{
          size: ButtonSize.LARGE,
          smSize: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
          text: 'DATERANGEPICKER.cancelBtn' | translate
        }"
      />

      <app-button
        [type]="'button'"
        [disabled]="loading"
        [loading]="loading"
        (onClick)="submit()"
        [config]="{
          size: ButtonSize.LARGE,
          smSize: ButtonSize.SMALL,
          type: ButtonTypes.NEW_PRIMARY_BLUE,
          text: 'DATERANGEPICKER.acceptBtn' | translate,
          prependSrc: './assets/img/tick-icon.svg'
        }"
      />
    </div>
  </div>
</div>
